import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Verification Bonus Settings</h4>
    </div>
  );
};
